import React, { Component } from 'react';
import { styled } from '@material-ui/core/styles';
import { Box, TextField, MenuItem, RadioGroup, FormControlLabel, Radio, Button, FormControl, FormHelperText, DialogTitle, DialogContent, DialogActions, Dialog } from '@material-ui/core';
import { timeFormat2 } from '../../../../../common/utils';
import { ADD, EDIT, ERR, globalData, CLIENT, CHILD, NORMAL, SPOUSE, TEXT, VIEW } from '../../../../../common/common';
import PanelSpouse from './PanelSpouse';
import PanelClient from './PanelClient';
import PanelChild from './PanelChild';
import PanelNormal from './PanelNormal';
import PanelList from './PanelList';

const Root = styled(Dialog)({
    width: '100%',
    '& .MuiGrid-item': {
        padding: '4px 12px'
    },
    '& .panel-wapper': {
        width: '100%',
        // padding: '10px',
        minHeight: '200px',
        '& .text-wapper': {
            width: '50%',
            paddingRight: '15px',
            '& .text-field': {
                width: '100%',
                // backgroundColor: '#FFFFFF',
            },
        },
        '& .text-title': {
            marginTop: '10px',
            fontSize: '14px',
            color: '#9B9B9B',
        },
    },
    '& .text-wapper-2': {
        width: '50%',
        paddingRight: '15px',
        '& .text-field-1': {
            width: '35%',
            backgroundColor: '#FFFFFF',
            paddingRight: '5px',
        },
        '& .text-field-2': {
            width: '65%',
            backgroundColor: '#FFFFFF',
        },
    },
    '& .p-10': {
        padding: '10px',
    },
    '& .tite-1': {
        fontSize: "16px",
        fontWeight: "bold",
        color: "#005E96",
        marginRight: "10px"
    },
    '& .tite-2': {
        color: "#979797"
    },
    '& .content': {
        width: "800px",
        overflowY: "auto"
    },
    '& .foot': {
        width: "100%",
        backgroundColor: "fff",
        padding: "10px"
    },
    '& .mr-10': {
        marginRight: "10px"
    },
})

class EditPanel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: {},
            open: false,
            dataINFO: {},
            panelType: 0,
            person: null
        }
        this.handleClose = this.handleClose.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.updateInfoData = this.updateInfoData.bind(this);
        this.pickPerson = this.pickPerson.bind(this);
    }
    render() {
        const {
            open,
            panelType,
            panelId,
            person
        } = this.state;
        const {
            dataINFO,
            data,
            isAdd
        } = this.props;
        const content = () => {
            if (panelType === CLIENT) {
                return <PanelClient
                    id={panelId}
                    isAdd={isAdd}
                    isUpdate={true}
                    dataINFO={dataINFO}
                    person={person}
                    updateInfoData={this.updateInfoData}
                    ref={(child) => { this.panelClient = child }}
                ></PanelClient>
            } else if (panelType === SPOUSE) {
                return <PanelSpouse
                    id={panelId}
                    isAdd={isAdd}
                    isUpdate={true}
                    dataINFO={dataINFO}
                    person={person}
                    updateInfoData={this.updateInfoData}
                    ref={(child) => { this.panelSpouse = child }}
                ></PanelSpouse>
            } else if (panelType === CHILD) {
                return <PanelChild
                    id={panelId}
                    isAdd={isAdd}
                    person={person}
                    updateInfoData={this.updateInfoData}
                    ref={(child) => { this.panelChild = child }}
                ></PanelChild>
            } else if (panelType === NORMAL) {
                return <PanelNormal
                    id={panelId}
                    isAdd={isAdd}
                    person={person}
                    updateInfoData={this.updateInfoData}
                    ref={(child) => { this.panelNormal = child }}
                ></PanelNormal>
            }
        }
        return (
            <Root maxWidth={false} open={open} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">
                    <span >{this.titleInfo()}</span>
                    <span style={{ color: "#979797" }}> - All relevant information will be changed after saving</span>
                </DialogTitle>
                <DialogContent dividers spacing={3}>
                    <div className="content">
                        {content()}
                        {/* <PanelList
                            pickPerson={this.pickPerson}
                        ></PanelList> */}
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button className="mr-10" variant="contained" onClick={this.handleClose}>Close</Button>
                    <Button variant="contained" color="primary" onClick={this.handleSave}>Save</Button>
                </DialogActions>
            </Root>
        )
    }
    componentDidMount() {
        console.log(this.props.panelType)
    }
    componentDidUpdate(prevProps) {
        const {
            open,
            dataINFO,
            panelId,
            panelType,
        } = this.props;
        if (prevProps.open !== open) {
            if (open) {
                this.initEditor(panelId, panelType);
            } else {
                this.setState({
                    open
                });
            }
        }
    }
    initEditor(panelId, panelType) {
        this.setState({
            open: true,
            panelId,
            panelType
        });
    }
    pickPerson(obj) {
        const { isAdd } = this.props;
        const panelType = obj.type;
        if (isAdd){
            this.setState({
                panelType,
                person: obj
            })
        }
    }
    handleClose(e) {
        console.log("shuchu", this.props.dataINFO)
        this.props.onClose();
    }
    handleSave(e) {
        const { panelType } = this.state;
        const { onClose } = this.props;
        if (typeof onClose !== 'function') {
            console.error("onClose is not a function");
            return
        }
        if (panelType === CLIENT) {
            this.panelClient.handleSave((isNext) => {
                if (isNext) onClose();
            });
        } else if (panelType === SPOUSE) {
            this.panelSpouse.handleSave((isNext) => {
                if (isNext) onClose();
            });
        } else if (panelType === CHILD) {
            this.panelChild.handleSave((isNext) => {
                if (isNext) onClose();
            });
        } else if (panelType === NORMAL) {
            this.panelNormal.handleSave((isNext) => {
                if (isNext) onClose();
            });
        }
    }
    updateInfoData(panelData, isAdd = false) {
        if (isAdd) {
            this.props.addInfoData(panelData);
        } else {
            this.props.updateInfoData(panelData);
        }
    }
    titleInfo() {
        const { panelType } = this.state;
        const { isAdd } = this.props;
        if (panelType === CLIENT) {
            return isAdd ? "Add Client Info" : "Edit Client Info";
        } else if (panelType === SPOUSE) {
            return isAdd ? "Add Spouse Info" : "Edit Spouse Info";
        } else if (panelType === CHILD) {
            return isAdd ? "Add Child Info" : "Edit Child Info";
        } else if (panelType === NORMAL) {
            return isAdd ? "Add Normal Info" : "Edit Normal Info";
        }
    }
}

export default EditPanel;